import React from 'react';

import {
  FiEye,
  FiBox,
  FiMapPin,
  FiShield,
  FiTool,
  FiCalendar,
  FiCpu,
  FiAlertTriangle,
  FiFileText,
} from 'react-icons/fi';

export default function EquipmentPreviewCard() {
  const equipmentData = {
    name: 'Walk-in Fridge',
    sku: 'REF-001',
    status: 'In Service',
    imageUrl: 'https://unsplash.com',

    details: [
      {
        id: 1,
        label: 'Category',
        value: 'Refrigeration',
        icon: FiBox,
        type: 'text',
      },
      {
        id: 2,
        label: 'Location',
        value: 'Kitchen',
        icon: FiMapPin,
        type: 'text',
      },
      {
        id: 3,
        label: 'Risk Level',
        value: 'Medium',
        icon: FiAlertTriangle,
        type: 'badge-warning',
      },
      {
        id: 4,
        label: 'Food Safety',
        value: 'Yes',
        icon: FiShield,
        type: 'success',
      },
      {
        id: 5,
        label: 'Next Maintenance',
        value: '20 May 2026',
        icon: FiTool,
        type: 'text',
      },
      {
        id: 6,
        label: 'Next PAT Due',
        value: '15 Apr 2026',
        icon: FiCalendar,
        type: 'text',
      },
      {
        id: 7,
        label: 'Warranty Expiry',
        value: '15 Jul 2028',
        icon: FiFileText,
        type: 'text',
      },
      {
        id: 8,
        label: 'Sensor',
        value: '2 Sensors (Live)',
        icon: FiCpu,
        type: 'success',
      },
    ],
  };

  return (
    <div className="max-w-sm bg-white rounded-2xl border border-slate-100 shadow-sm p-5 font-sans">

      {/* Header Section */}
      <div className="flex items-center space-x-2.5 pb-4 border-b border-dashed border-slate-100">
        <FiEye
          className="w-5 h-5 text-indigo-950"
          strokeWidth={2.5}
        />

        <h2 className="text-base font-bold text-indigo-950">
          Equipment Preview
        </h2>
      </div>

      {/* Main Info Card Row */}
      <div className="flex items-center space-x-4 my-5">

        {/* Product Image */}
        <div className="w-20 h-20 bg-slate-50 border border-slate-100 rounded-xl flex items-center justify-center p-2 overflow-hidden">
          <img
            src={equipmentData.imageUrl}
            alt={equipmentData.name}
            className="w-full h-full object-contain mix-blend-multiply"
          />
        </div>

        {/* Title Block */}
        <div className="flex flex-col items-start space-y-1">

          <h3 className="text-base font-bold text-indigo-950 leading-tight">
            {equipmentData.name}
          </h3>

          <span className="text-xs font-semibold text-slate-400 tracking-wider">
            {equipmentData.sku}
          </span>

          <span className="inline-flex items-center px-2.5 py-0.5 mt-1 rounded-md text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100">
            {equipmentData.status}
          </span>

        </div>
      </div>

      {/* Detailed Spec List */}
      <div className="space-y-3.5">

        {equipmentData.details.map((item) => {
          const Icon = item.icon;

          return (
            <div
              key={item.id}
              className="flex items-center justify-between text-sm"
            >

              {/* Left Label */}
              <div className="flex items-center space-x-3 text-slate-600">

                <Icon
                  className="w-[18px] h-[18px] text-indigo-950 shrink-0 opacity-80"
                  strokeWidth={2}
                />

                <span className="font-medium text-slate-600">
                  {item.label}
                </span>

              </div>

              {/* Right Value */}
              <div className="font-semibold text-indigo-950 text-right">

                {/* Normal Text */}
                {item.type === 'text' && (
                  <span>
                    {item.value}
                  </span>
                )}

                {/* Warning Badge */}
                {item.type === 'badge-warning' && (
                  <span className="inline-block px-2.5 py-0.5 rounded bg-amber-50 text-amber-600 text-xs font-bold border border-amber-100">
                    {item.value}
                  </span>
                )}

                {/* Success Text */}
                {item.type === 'success' && (
                  <span className="text-emerald-600 font-bold">
                    {item.value}
                  </span>
                )}

              </div>

            </div>
          );
        })}

      </div>
    </div>
  );
}